import { FC, useEffect, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Alert } from '@mui/material'
import Collapse from '@mui/material/Collapse'
import { ThemeProvider } from '@mui/material/styles'

import FadeAnimationDiv from 'components/common/Animations'
import { useTheme } from 'themes'

import { newFormThemeOverrides } from '../styles'
import { IAlertDocumentRequests } from '../types'
import { warningImg } from '../utils'

const AlertDocumentRequestsComponent: FC<IAlertDocumentRequests> = ({ handleClose, opened, formType }) => {
    const { formTheme } = useTheme({ formTheme: newFormThemeOverrides })
    const { t } = useTranslation()
    const [open, setOpen] = useState(false)
    const navigate = useNavigate()

    const personOnboarding = formType === 'PersonOnboarding'
    const companyOnboarding = formType === 'OnboardingForm'

    useEffect(() => {
        setOpen(opened)
    }, [opened])

    const buttonHandler = () => {
        handleClose()
        navigate('/settings/documents')
    }

    return (
        <FadeAnimationDiv>
            <ThemeProvider theme={formTheme}>
                <Collapse in={open} timeout={500}>
                    <Alert icon={false} className="warning userWarning">
                        <div className="iconBox">
                            <img className="iconImg" src={warningImg} alt={t('Alert.Warning')} />
                        </div>
                        <div className="message userWarning">
                            <span className="text">
                                {personOnboarding && (
                                    <Trans i18nKey="Alert.AlertDocumentRequestsComponent.Personal">
                                        To access this function your 'Personal application form' renewal and approval is required
                                    </Trans>
                                )}
                                {companyOnboarding && (
                                    <Trans i18nKey="Alert.AlertDocumentRequestsComponent.Company">
                                        To access this function your 'Company onboarding form' renewal and approval is required
                                    </Trans>
                                )}{' '}
                                <span style={{ fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap' }} onClick={buttonHandler}>
                                    {t('Alert.AlertDocumentRequestsComponent.GoToDocuments')}
                                </span>
                            </span>
                        </div>
                    </Alert>
                </Collapse>
            </ThemeProvider>
        </FadeAnimationDiv>
    )
}

export default AlertDocumentRequestsComponent
